import React, { useState } from 'react'
import BackgroundImage from '../../../images/public/01.jpg'
import LoginLogo from '../../../images/logos/iconwhite.png'
import ApiUrl from '../../../configTools/apiUrls'
import Publicinput from '../../../components/forms/publicinput'
import Publicbutton from '../../../components/forms/publicbutton'
import { Link } from 'react-router-dom'
import Facebook from './facebook'
import Google from './google'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import Functions from './funtions'

const Mobile = () => {
    const [username,setUsername] = useState('')
    const [password,setPassword] = useState('')
    const [passShow, setPassShow] = useState(false);
    async function post_login(){
        let res = await fetch(ApiUrl.API_URL_OAuth+"/login", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                username: username,
                password: password
            })
        })
        res = await res.json();
        if(res.success){
            localStorage.setItem("user-info",JSON.stringify(res.responce));
            document.location.reload();
        }
        else{
            alert(res.responce);
        }
    }
  return (
    <div className='v2_public_login_mobile_wrapper' style={{backgroundImage:`url(${BackgroundImage})`}}>
      <div className='v2_public_login_mobile_overlay'>
        <div className='v2_public_login_mobile_container'>
            <div className='v2_public_login_mobile_logo_container'>
                <div className='v2_public_login_mobile_logo_image'>
                    <img src={LoginLogo} alt='login_logo'/>
                </div>
                <h2>The easy way</h2>
                <h3>A platform where you can Buy-sell-Re sell or do it all over</h3>
            </div>
            <div className='v2_public_login_mobile_form_container'>
                <Publicinput Lable={'Username'} Placeholder={'Enter username'} Type={'text'} Value={username} setValue={setUsername}/>
                <Publicinput Lable={'Password'} Placeholder={'Enter password'} Type={passShow ? 'text' : 'password'} Value={password} setValue={setPassword} Icon={passShow ? <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEye}/> : <FontAwesomeIcon onClick={()=>{setPassShow(!passShow)}} icon={faEyeSlash}/>}/>
                <Publicbutton Value={'Log in'} Action ={()=>{
                    Functions.post_login({
                        username: username,
                        password: password
                    });
                }}/>
                <div className='v2_public_login_mobile_form_fpsu'>
                    <Link to={'#'}><p className='v2_public_login_mobile_form_fp'>Forgot password?</p></Link>
                    <Link to={'/signup'}><p className='v2_public_login_mobile_form_su'>Signup</p></Link>
                </div>
                <div className='v2_public_login_mobile_form_or'>
                    <p>or</p>
                </div>
                <div className='v2_public_login_mobile_form_social'>
                    <Facebook/>
                    <Google/>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Mobile
